import baseAPI from "@/api/base";
import { EditActivityLog, GetActivityLog, RegisterActivityLog } from "@/dtos/ActivityLog.dto";
import {
  DELETE_ACTIVITY_LOG_URL,
  EDIT_ACTIVITY_LOG_URL,
  GET_ACTIVITY_LOG_URL,
  REGISTER_ACTIVITY_LOG_URL,
  TOGGLE_ACTIVITY_LOG_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class ActivityLog {
  static getActivityLogs = async (getActivityLog: GetActivityLog): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ACTIVITY_LOG_URL, {
      params: getActivityLog,
    });
    return response;
  };

  static registerActivityLog = async (
    registerActivityLog: RegisterActivityLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_ACTIVITY_LOG_URL, {
      ...registerActivityLog,
    });
    return response;
  };

  static editActivityLog = async (editActivityLog: EditActivityLog): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_ACTIVITY_LOG_URL, {
      ...editActivityLog,
    });
    return response;
  };

  static toggleActivityLogIsActive = async (
    editActivityLog: EditActivityLog
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_ACTIVITY_LOG_IS_ACTIVE_URL, {
      ...editActivityLog,
    });
    return response;
  };

  static deleteActivityLog = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_ACTIVITY_LOG_URL}/${id}`);
    return response;
  };
}

export default ActivityLog;
